import type {CustomDealFilterOption} from './types';

export const CUSTOM_DEAL_ROUTES = {
  list: '/services/promotion-center/custom-deal',
  selectProducts: '/services/promotion-center/custom-deal/select-products',
  applyDiscount: '/services/promotion-center/custom-deal/apply-discount/:dealId',
  selectDate: '/services/promotion-center/custom-deal/select-date/:dealId',
  detail: '/services/promotion-center/custom-deal/detail/:dealId'
} as const;

export const CUSTOM_DEAL_HISTORY_STATE = {
  done: 'تکمیل شده',
  completed: 'تکمیل شده'
} as const;

export const CUSTOM_DEAL_STATUS_LABELS: Record<string, string> = {
  active: 'در حال اجرا',
  initiated: 'در صف اجرا'
};

export const CUSTOM_DEAL_PAGE_SIZE = 10;
export const CUSTOM_DEAL_PRESET_DISCOUNTS = [8, 10, 12] as const;

export const CUSTOM_DEAL_BADGE_OPTIONS: CustomDealFilterOption[] = [
  {label: 'بیشترین فروش شما', value: 1},
  {label: 'کمترین فروش شما', value: 2},
  {label: 'پرفروش منطقه', value: 3},
  {label: 'کم‌فروش منطقه', value: 4}
];

export const CUSTOM_DEAL_SORT_OPTIONS: CustomDealFilterOption[] = [
  {label: 'بیشترین فروش', value: '-top_seller'},
  {label: 'کمترین فروش', value: 'top_seller'},
  {label: 'بیشترین تخفیف', value: '-discount'},
  {label: 'کمترین تخفیف', value: 'discount'},
  {label: 'بیشترین قیمت', value: '-price'},
  {label: 'کمترین قیمت', value: 'price'},
  {label: 'بیشترین موجودی', value: '-stock'},
  {label: 'کمترین موجودی', value: 'stock'}
];

export const CUSTOM_DEAL_STOCK_STATUS_OPTIONS: CustomDealFilterOption[] = [
  {label: 'موجود', value: 1},
  {label: 'ناموجود', value: 2},
  {label: 'رو به اتمام', value: 3}
];
